import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import styles from './Skeleton.scss';

function SkeletonBar(props) {
    const { className } = props;

    return (
        <div
            className={classNames(
                className,
                styles.animation,
                styles.bar,
            )}
        />
    );
}

SkeletonBar.propTypes = {
    className: PropTypes.string,
};

function SkeletonCheckbox(props) {
    const {
        barClassName,
        checkboxClassName,
    } = props;

    return (
        <div className={styles.barRow}>
            <div
                className={classNames(
                    checkboxClassName,
                    styles.animation,
                    styles.checkbox,
                )}
            />
            <SkeletonBar className={barClassName} />
        </div>
    );
}

SkeletonCheckbox.propTypes = {
    barClassName: PropTypes.string,
    checkboxClassName: PropTypes.string,
};

function SkeletonDivider(props) {
    const { className } = props;

    return (
        <div className={classNames(className, styles.divider)} />
    );
}

SkeletonDivider.propTypes = {
    className: PropTypes.string,
};

function Skeleton(props) {
    const {
        className = '',
        children,
    } = props;

    return (
        <div className={classNames(className, styles.container)}>
            {children}
        </div>
    );
}

Skeleton.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
};

export {
    Skeleton,
    SkeletonBar,
    SkeletonCheckbox,
    SkeletonDivider,
};

export default Skeleton;
